import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnumObject } from '@card-software/library';
import { environment } from '../../environments/environment';

/** Item.API enums (e.g. UnitOfMeasure). Loaded + localStorage-cached by the finance EnumService. */
@Injectable({ providedIn: 'root' })
export class ItemEnumsProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/enums';

  public getAll(): Observable<EnumObject[]> {
    return this.httpClient.get<EnumObject[]>(this.baseUrl);
  }
}
